import { useParameterStore } from "@/frontend/store/ParameterStore";
import { I18n } from "@/i18n/I18n";
import { ParameterType } from "@/types/parameterTypes";
import { Parameter } from "@/backend/models/parameter";
import { Dropdown } from "react-bootstrap";
import { useTreeStore } from "@/frontend/store/TreeStore";
import { useGlobalStore } from "@/frontend/store/GlobalStore";
import { FusaToastType } from "@/frontend/toasts/types";
import { embedOnlyLink } from "@/frontend/embed/embedApp";

export function ChangeTypeItem(props: { parameter: Parameter  }) {
  const { parameter } = props;
  const updateParameter = useParameterStore(state => state.updateParameter);
  const addToast = useGlobalStore(state => state.addToast);
  const containers = useTreeStore(state => state.containers);
  const operations = useTreeStore(state => state.operations);

  const getErrorMessage = () => {
    const rangeContainer = containers.find(container => container.rangeParameterId === parameter.id);
    const rangeOperation = operations.find(operation => operation.rangeParameterId === parameter.id);

    const rangeItem = rangeContainer || rangeOperation;
    if (rangeItem) {
      return { message: I18n.get('configCouldNotBeUpdatedToInputBecauseItIsUsedForRangingBy'), item: rangeItem };
    }

    const skipContainer = containers.find(container => container.skipParameterId === parameter.id);
    const skipOperation = operations.find(operation => operation.skipParameterId === parameter.id);
    const skipItem = skipContainer || skipOperation;
    if (skipItem) {
      return { message: I18n.get('configCouldNotBeUpdatedToInputBecauseItIsUsedForSkippingBy'), item: skipItem };
    }

    const conditionalContainer = containers.find(container => parameter.fields.some(field => field.id === container.conditionalFieldId));
    if (conditionalContainer) {
      return { message: I18n.get('configCouldNotBeUpdatedToInputBecauseItIsUsedForSettingStepVisibilityBy'), item: conditionalContainer };
    }

    return null;
  };

  const updateType = async (type: ParameterType) => {
    const error = getErrorMessage();

    if (error) {
      addToast({
        message: error.message,
        link: embedOnlyLink(`/procedures/scaffold/${error.item.rootId}#${error.item.id}`),
        linkText: error.item.title || I18n.get(error.item.type),
        header: I18n.get('error'),
        type: FusaToastType.ERROR,
      });
      return;
    }
    void updateParameter({ parameter: { ...parameter, type } });
  };


  if (parameter.type === ParameterType.CONFIG) {
    return (
      <Dropdown.Item onClick={() => void updateType(ParameterType.INPUT)}>
        {I18n.get('updateToInput')}
      </Dropdown.Item>
    );
  }

  return null;
}

